import Checkbox from "@Components/Inputs/Checkbox";
import states from "@Utils/states";
import React, { useState } from "react";
import styles from "../styles.module.scss";

interface StateSelectProps {
  stateId: string | null | undefined;
  onSelect: (
    stateId: string | null,
    basedOnLocationOf: "applicant" | "dealer"
  ) => void;
  className?: string;
  allAvailableStates?: string[];
  defaultState?: string | null;
  defaultBasedOnLocationOf?: "applicant" | "dealer";
}

const StateSelect: React.FC<StateSelectProps> = ({
  onSelect,
  className,
  stateId,
  allAvailableStates,
  defaultState,
  defaultBasedOnLocationOf,
}) => {
  const [selectedStateId, setSelectedStateId] = useState<string | null>(
    defaultState || "All States"
  );
  const [basedOnLocationOf, setBasedOnLocationOf] = useState<
    "applicant" | "dealer"
  >(defaultBasedOnLocationOf || "dealer");
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSelect = () => {
    if (selectedStateId === "All States") onSelect(null, basedOnLocationOf);
    else onSelect(selectedStateId, basedOnLocationOf);
    setIsOpen(false);
  };

  const getDisplayText = () => {
    const selectedState = (allAvailableStates || Object.keys(states))?.find(
      (state) => state === stateId
    );
    return stateId ? selectedState : "All States";
  };

  return (
    <div className={`${styles.selectContainer} ${className || ""}`}>
      <div className={styles.selectButton} onClick={() => setIsOpen(!isOpen)}>
        <span>{getDisplayText()}</span>
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
        >
          <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" />
        </svg>
      </div>

      {isOpen && (
        <div className={styles.dropdown}>
          <div style={{ margin: 15 }}>
            <div
              style={{
                fontSize: 12,
              }}
            >
              Based on location of:
            </div>
            <div className={styles.filtersButtonModalCheckboxes}>
              <div>
                <Checkbox
                  placeholder={"Applicant"}
                  id={"applicant"}
                  name={"applicant"}
                  checked={basedOnLocationOf === "applicant"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setBasedOnLocationOf("applicant");
                    }
                  }}
                />
              </div>
              <div>
                <Checkbox
                  placeholder={"Dealer"}
                  id={"dealer"}
                  name={"dealer"}
                  checked={basedOnLocationOf === "dealer"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setBasedOnLocationOf("dealer");
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.dropdownHeader}>
            <div className={styles.yearSelect}>
              <label>State</label>
              <select
                style={{ width: "100%" }}
                value={selectedStateId ?? "Select State"}
                onChange={(e) => setSelectedStateId(e.target.value)}
              >
                <option value="All States">All States</option>

                {(allAvailableStates || Object.keys(states) || []).map(
                  (state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  )
                )}
              </select>
            </div>
          </div>

          <div className={styles.dropdownFooter}>
            <button
              className={styles.cancelButton}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
            <button className={styles.applyButton} onClick={handleSelect}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StateSelect;
